import React, { useEffect, useState } from 'react';
import { Checkbox, Form } from 'antd';
import styles from './enableAction.module.scss';
import { getIn18Text, api } from 'api';
import SiriusModal from '@web-common/components/UI/Modal/SiriusModal';
const systemApi = api.getSystemApi();
export const EnableAction = props => {
    const { enable, form, isDisable, selectedAction, _account, showHisExec, isBodyCondition } = props;
    const [options, setOptions] = useState([]);
    useEffect(() => {
        form.setFieldsValue({ enable });
    }, [enable, form]);
    useEffect(() => {
        const opts = [
            {
                label: getIn18Text('GUIZELIJIQI'),
                value: 'effectMail',
            },
        ];
        if (showHisExec) {
            opts.push({
                label: getIn18Text('QIYONGQIEBAOCUN'),
                value: 'effectHistoryMail',
                disabled: isDisable,
            });
        }
        setOptions(opts);
        const enableList = form.getFieldValue('enable') || [];
        if ((isDisable || !showHisExec || isBodyCondition) && enableList.includes('effectHistoryMail')) {
            form.setFieldsValue({ enable: enableList.filter(i => i !== 'effectHistoryMail') });
        }
    }, [isDisable, selectedAction, showHisExec, isBodyCondition]);
    const handleEnableChange = (checkedValues) => {
        if (isBodyCondition && checkedValues.includes('effectHistoryMail')) {
            SiriusModal.info({
                content: getIn18Text('规则条件中包含邮件正文历史邮件无法执行'),
                okText: getIn18Text('QUEREN'),
                okCancel: false,
            });
            form.setFieldsValue({ enable: checkedValues.filter(v => v !== 'effectHistoryMail') });
        }
    };
    return (React.createElement(Form.Item, { name: "enable", className: `ant-allow-dark ${styles.classifyEnable}` },
        React.createElement(Checkbox.Group, { options: options, onChange: handleEnableChange })));
};
